module.exports = __webpack_public_path__ + "img/colorPickerTriangle.ff994688.svg";